/* ================= TWS WAVEFOLD — scroll-driven wavy reveal =================
   Inits every [data-wavefold] on the page (no section.id needed), so multiple
   instances are safe. Per instance: one rAF-throttled scroll handler reads
   geometry once per frame then writes only transform/opacity (no mid-scroll
   relayout), a numbers-generated layered-liquid bottom edge, and the rotating
   word. Mirrors design-system/ui_kits/website/index.html. */
(function () {
  'use strict';

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- scroll-pinned sweep + layered-liquid edge ---------- */
  function initWave(root) {
    var panel  = root.querySelector('.wf-panel');
    var inner  = root.querySelector('.wf-panel-inner');
    var wave   = root.querySelector('.wf-wave');
    var reveal = root.querySelector('.wf-reveal');
    var botPath = root.querySelector('[data-wf-front]');
    var botBack = root.querySelector('[data-wf-back]');
    if (!panel || !inner || !wave || !reveal) return;

    if (reduceMotion()) { reveal.classList.add('is-in'); return; } /* CSS unpins it */

    var ticking = false, listening = false, vh = 0, waveH = 0, trackH = 0, lastP = 0, liquidRAF = null;

    function measure() {
      vh = window.innerHeight;
      trackH = root.offsetHeight;
      waveH = wave.getBoundingClientRect().height;
    }

    /* smooth curve through evenly spaced control points: flat top, wavy bottom */
    function smoothWave(ys) {
      var n = ys.length - 1, dx = 1440 / n;
      var d = 'M0,' + ys[0].toFixed(1);
      for (var i = 0; i < n; i++) {
        var x0 = i * dx, x1 = x0 + dx;
        d += ' C' + (x0 + dx / 3).toFixed(1) + ',' + ys[i].toFixed(1)
           + ' ' + (x1 - dx / 3).toFixed(1) + ',' + ys[i + 1].toFixed(1)
           + ' ' + x1.toFixed(1) + ',' + ys[i + 1].toFixed(1);
      }
      return d + ' L1440,0 L0,0 Z';
    }

    function liquidPaths(phase) {
      var front = [], back = [], lag = phase - 0.6, i;
      for (i = 0; i <= 7; i++) {
        front.push(72 + Math.sin(phase * 0.62 + i * 1.15 + 1.4) * 20 + Math.sin(phase * 1.35 + i * 1.95) * 11);
        /* under-curve runs at a phase lag + wider amplitude, so the two drift
           in and out of each other instead of moving as one rigid shape */
        back.push(72 + Math.sin(lag * 0.62 + i * 1.15 + 1.4) * 23 + Math.sin(lag * 1.35 + i * 1.95) * 13);
      }
      if (botPath) botPath.setAttribute('d', smoothWave(front));
      if (botBack) botBack.setAttribute('d', smoothWave(back));
    }

    function update() {
      ticking = false;
      var top = root.getBoundingClientRect().top; /* single geometry read */
      var dist = trackH - vh;                     /* pinned scroll distance */
      var p = dist > 0 ? (-top / dist) : 0;
      p = p < 0 ? 0 : (p > 1 ? 1 : p);

      /* panel sweeps up by a full viewport plus the wave that hangs below it */
      panel.style.transform = 'translate3d(0,' + (-(p * (vh + waveH))) + 'px,0)';

      /* headline lags behind the sweep so it holds centre, then fades out */
      inner.style.transform = 'translate3d(0,' + (p * vh * 0.52) + 'px,0)';
      inner.style.opacity = p < 0.62 ? 1 : Math.max(0, 1 - (p - 0.62) / 0.26);

      /* curve settles/flattens as the sweep completes */
      wave.style.transform = 'scaleY(' + (p < 0.55 ? 1 : Math.max(0.32, 1 - (p - 0.55) / 0.45 * 0.68)) + ')';

      /* staggered copy fades in once the curve has cleared it */
      if (p > 0.5) reveal.classList.add('is-in'); else reveal.classList.remove('is-in');

      lastP = p;
      liquidPaths(p * 9 + (performance.now() / 1000) * 0.5);
    }

    function liquidFrame(now) {
      if (!listening) { liquidRAF = null; return; }
      liquidPaths(lastP * 9 + (now / 1000) * 0.5);
      liquidRAF = requestAnimationFrame(liquidFrame);
    }

    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    function listen(on) {
      if (on === listening) return;
      listening = on;
      if (on) window.addEventListener('scroll', onScroll, { passive: true });
      else window.removeEventListener('scroll', onScroll);
      /* the ambient liquid loop only runs while the section is on screen */
      if (on && !liquidRAF) liquidRAF = requestAnimationFrame(liquidFrame);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        listen(entries[0].isIntersecting);
        if (entries[0].isIntersecting) onScroll();
      }, { rootMargin: '250px 0px' }).observe(root);
    } else {
      listen(true);
    }

    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
    measure();
    update();
  }

  /* ---------- rotating word ---------- */
  function initRotator(root) {
    var rot = root.querySelector('.rotator');
    var trackEl = root.querySelector('[data-wf-track]');
    if (!rot || !trackEl) return;
    var words = Array.prototype.slice.call(trackEl.children);

    /* width follows the active word so the line never jumps */
    function fit(k) { if (words[k]) rot.style.width = words[k].getBoundingClientRect().width + 'px'; }
    fit(0);

    var n = words.length - 1; /* last child is the clone of the first */
    if (n < 2) {              /* 0–1 real words: show it statically, keep width fitted */
      window.addEventListener('resize', function () { fit(0); }, { passive: true });
      return;
    }

    var STEP = 1.3;           /* em — must match .rotator-mask height */
    var i = 0;
    window.addEventListener('resize', function () { fit(i); }, { passive: true });

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var interval = parseInt(root.getAttribute('data-rotate-interval'), 10) || 2400;
    window.setInterval(function () {
      i++;
      trackEl.style.transform = 'translate3d(0,-' + (i * STEP) + 'em,0)';
      fit(i);
      if (i === n) {          /* landed on the clone — snap back unseen */
        window.setTimeout(function () {
          trackEl.style.transition = 'none';
          trackEl.style.transform = 'translate3d(0,0,0)';
          i = 0;
          void trackEl.offsetWidth; /* commit, then restore easing */
          trackEl.style.transition = '';
        }, 820);
      }
    }, interval);
  }

  function init() {
    var roots = document.querySelectorAll('[data-wavefold]');
    for (var i = 0; i < roots.length; i++) { initWave(roots[i]); initRotator(roots[i]); }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
